import { motion, AnimatePresence } from "motion/react";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import apiCumbres from "../axios/axios";
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Modal, Box, IconButton } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { sxTableHead } from "./Styles";

const Home = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [listadoProximosAbonos, setListadoProximosAbonos] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openModal, setOpenModal] = useState(false)


    const obtenerProximosAbonos = () => {


        const obtener = async () => {

            try {

                const obteniendo = await apiCumbres.get('/home/proximos-abonos')

                setListadoProximosAbonos(obteniendo.data)
                setOpenModal(true)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener pagos proximos de préstamos, favor de volver a recargar!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }


        obtener()

    }


    useEffect(() => {

        obtenerProximosAbonos()

    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const formatFecha = (value) => {

        const fecha = new Date(value + ' 08:00:00')
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate().toString().padStart(2, '0')} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`

    }


    return (
        <>
            {isLoading ?
                <LoadingSpinner />
                : null}
            <div className="d-flex justify-content-center align-items-center  bg-gradient" style={{ background: 'linear-gradient(135deg, #4e54c8, #8f94fb)' }}>
                <div
                    className="card shadow-lg text-center p-5 border-0"
                    style={{ borderRadius: '20px', backgroundColor: '#ffffff' }}
                >
                    {/* Logo con animación */}
                    <motion.img
                        src={'/img/logoCumbres.png'}
                        alt="Logo"
                        className="mb-4"
                        style={{ width: '250px', height: '250px' }}
                        initial={{ opacity: 0, y: -30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.6 }}
                    />

                    {/* Texto de bienvenida */}
                    <motion.h1
                        className="mb-3"
                        style={{ color: '#0a2540', fontWeight: '700' }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.6 }}
                    >
                        Bienvenido a CUMBRES
                    </motion.h1>

                    <motion.p
                        className="mb-4"
                        style={{ color: '#1e88e5', fontSize: '1.1rem' }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.7, duration: 0.6 }}
                    >
                        Gestiona tus préstamos y clientes de manera sencilla y eficiente
                    </motion.p>


                </div>





            </div>

            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <>
                    {isLoading ?
                        <LoadingSpinner />
                        : null}
                    {/* BACKDROP ANIMADO */}
                    <motion.div
                        key="backdrop"
                        initial={{ opacity: 0, backdropFilter: "blur(0px)" }}
                        animate={{ opacity: 1, backdropFilter: "blur(4px)" }}
                        exit={{ opacity: 0, backdropFilter: "blur(0px)" }}
                        transition={{ duration: 0.3 }}
                        style={{
                            position: "fixed",
                            inset: 0,
                            background: "rgba(0,0,0,0.45)",
                            zIndex: -1
                        }}
                        onClick={() => setOpenModal(false)}
                    />

                    <motion.div
                        initial={{ opacity: 0, scale: 0.6, rotate: -3 }}
                        animate={{ opacity: 1, scale: 1, rotate: 0 }}
                        exit={{ opacity: 0, scale: 0.8, rotate: 2 }}
                        transition={{
                            duration: 0.35,
                            ease: [0.25, 0.8, 0.25, 1]
                        }}
                        style={{ outline: "none" }}
                    >
                        <Box
                            sx={{
                                width: "min(1200px, 95vw)",
                                maxHeight: "90vh",     // 🔑 permite crecer o encogerse
                                minHeight: "300px",
                                bgcolor: "background.paper",
                                borderRadius: "12px",
                                boxShadow: 24,
                                position: "relative",
                                mx: "auto",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                            }}
                        >
                            {/* TACHITA */}
                            <IconButton
                                onClick={() => setOpenModal(false)}
                                sx={{ position: "absolute", top: 8, right: 8 }}
                            >
                                <HighlightOffIcon className="text-danger" />
                            </IconButton>

                            <Box sx={{ p: 3, flexShrink: 0 }}>
                                <motion.h1 className="color-primary"
                                    initial={{ opacity: 0, y: -90 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}>
                                    Próximos Abonos
                                </motion.h1>
                                <hr className="mb-5" />
                            </Box>

                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: "auto",   // 🔥 aquí vive el scroll vertical
                                    overflowX: "hidden",
                                    minWidth: 0,
                                    px: 3,
                                    pb: 2,
                                }}
                            >

                                <TableContainer component={Paper} sx={{
                                    width: "100%",
                                    overflowX: "auto",   // 🔥 horizontal
                                    overflowY: "visible",
                                }}>
                                    <Table >
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                <TableCell sx={sxTableHead}>Folio</TableCell>
                                                <TableCell sx={sxTableHead}>Fecha</TableCell>
                                                <TableCell sx={sxTableHead}>Monto Total</TableCell>
                                                <TableCell sx={sxTableHead}>Monto Capital</TableCell>
                                                <TableCell sx={sxTableHead}>Capital Abonado</TableCell>
                                                <TableCell sx={sxTableHead}>Monto Interes</TableCell>
                                                <TableCell sx={sxTableHead}>Interes Abonado</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            <AnimatePresence component={null}>
                                                {listadoProximosAbonos
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((abonos, index) => (
                                                        <motion.tr
                                                            key={index}
                                                            initial={{ opacity: 0, x: -50 }}
                                                            animate={{ opacity: 1, x: 0 }}
                                                            exit={{ opacity: 0, y: -40 }}
                                                            transition={{
                                                                duration: 0.4,
                                                                ease: "easeOut",
                                                                delay: 0.1 * index
                                                            }}
                                                            style={{
                                                                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                            }}
                                                        >
                                                            <TableCell>CI-{String(abonos['contratos_prestamo.contratos_folio.folio']).padStart(5, '0')}</TableCell>
                                                            <TableCell>{formatFecha(abonos.fechaAbono)}</TableCell>
                                                            <TableCell>${formatNumber(abonos.monto)}</TableCell>
                                                            <TableCell>${formatNumber(abonos.montoCapital)}</TableCell>
                                                            <TableCell className={!abonos.fechaAbonadoCapital ? 'text-danger' : 'text-success'}>
                                                                {!abonos.fechaAbonadoCapital ? 'SIN REGISTRO' : formatFecha(abonos.fechaAbonadoCapital)}
                                                            </TableCell>
                                                            <TableCell>${formatNumber(abonos.montoInteres)}</TableCell>
                                                            <TableCell className={!abonos.fechaAbonadoInteres ? 'text-danger' : 'text-success'}>
                                                                {!abonos.fechaAbonadoInteres ? 'SIN REGISTRO' : formatFecha(abonos.fechaAbonadoInteres)}
                                                            </TableCell>

                                                        </motion.tr>
                                                    ))}
                                            </AnimatePresence>
                                        </TableBody>
                                    </Table>
                                    <Box sx={{ flexShrink: 0 }}>
                                        <TablePagination
                                            component="div"
                                            count={listadoProximosAbonos.length}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            rowsPerPage={rowsPerPage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            labelRowsPerPage="Registros por página"
                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                        />
                                    </Box>

                                </TableContainer>
                            </Box>



                        </Box>
                    </motion.div>
                </>
            </Modal>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </>
    )

}

export default Home